"use client";

import type { ReactElement } from "react";
import "../developers/_components/developers-funnel.css";
import "./careers.css";
import "./careers-redesign.css";
import "./careers-benefits.css";
import type { CareersLang } from "./careers-constants";
import { CareersDevTeaser } from "./careers-dev-teaser";
import { CareersFooter } from "./careers-footer";
import { CareersGrowthSection } from "./careers-growth-section";
import { CareersHero } from "./careers-hero";
import { CareersJobsSection } from "./careers-jobs-section";
import { CareersLanguageProvider } from "./careers-language-context";
import { CareersLocationSection } from "./careers-location-section";
import { CareersProcessSection } from "./careers-process-section";
import { CareersTopbar } from "./careers-topbar";
import { CareersWorkSection } from "./careers-work-section";

/**
 * Karriere/Careers marketing page on the developer-funnel design system
 * (dark canvas, Inter, teal accents, white stage cards).
 * Story: product → offer (office + benefits) → growth → jobs → process.
 * URL is source of truth for the language: /careers = DE, /careers/en = EN.
 */
export function CareersPage({
  lang = "de",
}: {
  readonly lang?: CareersLang;
}): ReactElement {
  return (
    <CareersLanguageProvider initialLang={lang}>
      <div className="dvf c2">
        <CareersTopbar />
        <CareersHero />
        <CareersWorkSection />
        <CareersLocationSection />
        <CareersGrowthSection />
        <CareersDevTeaser />
        <CareersJobsSection />
        <CareersProcessSection />
        <CareersFooter />
      </div>
    </CareersLanguageProvider>
  );
}
